import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonContent } from "@ionic/angular";
import { OrderService } from 'src/app/shared-lib/domains/order';
import { ShippingLabelService } from 'src/app/shared-lib/domains/shipping-label';
import { OrderProcessStatus, TrackingData } from '../shared-lib/domains/order';
import { OrderPaymentStatus } from '../shared-lib/domains/payment';

import { AppService } from "../shared/app.service";

@Component({
  selector: 'app-get-client-shipping-info',
  templateUrl: './get-client-shipping-info.component.html',
  styleUrls: ['./get-client-shipping-info.component.scss'],
  standalone: false
})
export class GetClientShippingInfoComponent implements OnInit {
  @ViewChild('content', { static: false }) content: IonContent;
  order = null;
  shippingInfoForm: FormGroup;
  submitErrorMessage: string = '';
  showTrackingData = false;
  trackingData: TrackingData;

  constructor(
    public appService: AppService,
    private fb: FormBuilder,
    private orderService: OrderService,
    private shippingLabelService: ShippingLabelService
  ) {
    this.shippingInfoForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      orderNumber: ['', [Validators.required, Validators.pattern('^[0-9]+$')]]
    });
  }

  ngOnInit(): void {
    this.shippingInfoForm.valueChanges.subscribe(() => {
      this.submitErrorMessage = '';
    });
  }

  getErrorMessage(controlName: string): string {
    const control = this.shippingInfoForm.get(controlName);

    if (control?.hasError('required')) {
      return 'Este campo es obligatorio.';
    } else if (control?.hasError('email')) {
      return 'Introduce una dirección de email válida.';
    } else if (control?.hasError('pattern')) {
      return 'Se han detectado caracteres inválidos.';
    }

    return '';
  }

  filterNonNumeric(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  async onSubmit() {
    if (this.shippingInfoForm.valid) {
      //TODO: esto deberia ser una función cloud que reciba email y número de pedido, valide que coinciden y devuelva la información de tracking, para no exponer la consulta a firestore desde el cliente
      const email = this.shippingInfoForm.value.email;
      const orderNumber = Number(this.shippingInfoForm.value.orderNumber);
      const orderResult = await this.orderService.getOrderByEmailAndNumber(email, orderNumber);

      if (!orderResult) {
        this.showTrackingData = false;
        this.submitErrorMessage = 'No se ha encontrado ningún pedido con esos datos';
        return;
      } else {
        const data = orderResult.data as any;
        const shippingLabelId = data.shippingLabelId;
        const shippingEstimatedDelivery = data.shippingEstimatedDelivery;
        const shippingCourierService = data.shippingCourierService;
        const processStatus = data.processStatus;
        const paymentStatus = data.paymentStatus;
        const shippingDelayReported = data.shippingDelayReported;
        const shippingAddress = {};
        shippingAddress['pickupPointCode'] = data?.shippingAddress?.pickupPointCode;
        if (paymentStatus !== OrderPaymentStatus.PAID || ![OrderProcessStatus.PENDING, OrderProcessStatus.PROCESSING,
        OrderProcessStatus.COMPLETE, OrderProcessStatus.SHIPPED].includes(processStatus)) {
          this.showTrackingData = false;
          this.submitErrorMessage = 'No existe un envío asociado a este pedido';
          return;
        }

        if (shippingLabelId) {
          const shippingLabel = await this.shippingLabelService.getShippingLabel(shippingLabelId);
          if (!shippingLabel) {
            this.showTrackingData = false;
            this.submitErrorMessage = 'Ha ocurrido un error al consultar el envío.';
            return;
          }

          const {
            expectedDeliveryDate = null,
            internalStatus = null,
            onTime = null,
            pickupDate = null,
            url = null
          } = shippingLabel?.tracking || {};

          this.trackingData = {
            internalStatus: internalStatus || null,
            minDeliveryDate: shippingEstimatedDelivery?.minDeliveryDate ? new Date(shippingEstimatedDelivery?.minDeliveryDate.seconds * 1000)
              : null,
            maxDeliveryDate: shippingEstimatedDelivery?.maxDeliveryDate ? new Date(shippingEstimatedDelivery?.maxDeliveryDate.seconds * 1000)
              : null,
            url
          };

        } else {
          this.trackingData = {
            internalStatus: null,
            minDeliveryDate: shippingEstimatedDelivery?.minDeliveryDate ? new Date(shippingEstimatedDelivery?.minDeliveryDate.seconds * 1000)
              : null,
            maxDeliveryDate: shippingEstimatedDelivery?.maxDeliveryDate ? new Date(shippingEstimatedDelivery?.maxDeliveryDate.seconds * 1000)
              : null,
            url: null
          };
        }
        this.order = {
          id: data.id,
          shippingCourierService,
          processStatus,
          paymentStatus,
          shippingAddress,
          number: orderNumber,
          shippingDelayReported
        };
        this.showTrackingData = true;
        return;
      }
    }

  }

  scrollToBottom() {
    if (this.content)
      this.content.scrollToBottom(500);
  }

}

